import { render, staticRenderFns } from "./soa.vue?vue&type=template&id=11e8327c&"
import script from "./soa.vue?vue&type=script&lang=js&"
export * from "./soa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports